import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useStore } from "../context/StoreContext";
import { formatPrice, mediaUrl } from "../lib/api";

export default function ProductCard({ product, index = 0 }) {
  const { toggleWishlist, inWishlist } = useStore();
  const sold = product.availability_status === "sold" || product.availability_status === "reserved";
  const img = mediaUrl((product.images || [])[0]);
  const img2 = mediaUrl((product.images || [])[1]);
  const wished = inWishlist(product.id);

  return (
    <div className="group animate-fade-in-up" style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
      data-testid="product-card">
      <Link to={`/product/${product.slug || product.id}`} className="block relative bg-bone aspect-[4/5] overflow-hidden">
        {img && <img src={img} alt={`${product.brand} ${product.title}`} loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]" />}
        {img2 && <img src={img2} alt="" loading="lazy"
          className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-500" />}
        <span className="absolute top-3 left-3 bg-ivory/90 backdrop-blur-sm text-[10px] font-mono uppercase tracking-widest px-2.5 py-1 text-charcoal border border-linen">
          {product.condition}
        </span>
        {product.inventory_quantity === 1 && !sold && (
          <span className="absolute bottom-3 left-3 bg-pitch text-ivory text-[10px] font-mono uppercase tracking-widest px-2 py-0.5">One of One</span>
        )}
        {sold && (
          <div className="absolute inset-0 bg-pitch/55 backdrop-blur-[1px] flex items-center justify-center" data-testid="product-card-sold-badge">
            <span className="text-xs font-mono tracking-[0.3em] uppercase text-white border border-white/50 px-5 py-2 bg-pitch/70">Sold</span>
          </div>
        )}
      </Link>
      <div className="relative pt-4">
        <button onClick={() => toggleWishlist(product)} aria-label="Toggle wishlist"
          data-testid="product-card-wishlist"
          className="absolute right-0 top-4 p-1 text-charcoal hover:text-vermilion transition-colors">
          <Heart className={`w-[18px] h-[18px] ${wished ? "fill-vermilion text-vermilion" : ""}`} />
        </button>
        <div className="text-xs font-mono uppercase tracking-[0.18em] text-stonemuted pr-8">{product.brand}</div>
        <Link to={`/product/${product.slug || product.id}`}>
          <h3 data-testid="product-card-title"
            className="font-serif text-base sm:text-lg text-pitch mt-1 leading-snug pr-8 group-hover:text-champagne-dark transition-colors">
            {product.title}
          </h3>
        </Link>
        <div className="flex items-baseline gap-2 mt-1.5">
          <span data-testid="product-card-price" className="text-sm font-medium text-pitch">{formatPrice(product.price, product.currency)}</span>
          {product.original_retail_price && (
            <span className="text-xs line-through text-stonemuted">{formatPrice(product.original_retail_price, product.currency)}</span>
          )}
        </div>
      </div>
    </div>
  );
}
